import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import cards from "./cards";

const useStyles = makeStyles({
  imageBackground: {
    background: "transparent no-repeat center center",
    backgroundSize: "100%",
    verticalAlign: "middle",
    display: "inline-block",
  },
});

const PaymentCardsLogos = ({ imageKey, width, height }) => {
  const classes = useStyles();
  const card = cards[imageKey.toLowerCase()];
  return card ? (
    <span
      className={classes.imageBackground}
      style={{
        backgroundImage: `url(${card.src})`,
        width: width ? width : "28px",
        height: height ? height : "16px",
      }}
      title={card.label}
    />
  ) : (
    imageKey
  );
};

PaymentCardsLogos.propTypes = {
  imageKey: PropTypes.string,
};

PaymentCardsLogos.defaultProps = {
  imageKey: "",
};

export default PaymentCardsLogos;
